export default "__VITE_ASSET__BGs9l$VH__"